import st from "@/styles/LoginPage.module.scss";
import {country_code} from "@/utils/constants.ts";
import DashboardClass from "@/utils/dashboard_class.ts";
import EditIcon from "@/svg/EditIcon.tsx";
import WritePinFields from "@/ui/WritePinFields.tsx";
import Button from "@/ui/Button.tsx";
import ChevroneIcon from "@/svg/ChevronIocn.tsx";
import clsx from "clsx";
import Countdown, {CountdownRenderProps} from "react-countdown";
import CircleArrow from "@/svg/CircleArrow.tsx";
import LoginLoader from "@/ui/LoginLoader.tsx";
import React, {useEffect, useRef, useState} from "react";
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";
import useAuth from "@/hooks/auth.ts";
import {useAtom} from "jotai";
import {profile} from "@/atoms/profile.ts";
import {pin_value} from "@/atoms/common.ts";
import CommonClass from "@/utils/common.ts";
import LoginData from "@/types_and_interfaces/login_data.ts";


const WriteOTPSecondStep = () => {


    const {t} = useTranslation()
    const navigate = useNavigate();
    const formRef = useRef<HTMLFormElement>(null)
    const loginData = localStorage.getItem(CommonClass.local_storage_fields.login_data)

    const data:LoginData = loginData ?  JSON.parse(loginData) : {}
    const [countEnd, setCountEnd] = useState(false)
    const [reqLoad, setReqLoad] = useState<boolean>(false)
    const [error, setError] = useState<boolean>(false)
    const queryParams = new URLSearchParams(location.search);
    const debug = queryParams.get("debug")
    const isAttemptsErr = queryParams.get("isAttemptsErr");
    const [user, ] = useAtom(profile)
    const [pin, setPin] = useAtom(pin_value);
    const effectRan = useRef<boolean>(false)
    const init_pin = ['', '', '', '']
    const auth = useAuth()

    const handleSetReqLoad = (event:any) => {
        const { load } = event.detail;
        setReqLoad(load);
    };

    const handleSetError = (event:any) => {
        const { load } = event.detail;
        setError(load);
    };

    const resend = async () => {
        setReqLoad(true)
        setError(false)

        await auth.resendOtpUniversalFunction(data).then((ok:boolean) => {
            if(ok) setCountEnd(false)
            setReqLoad(false)
        })
    }

    const countDownCompleteHandler = () => {
        localStorage.setItem( CommonClass.local_storage_fields.login_data, JSON.stringify({
            type:data.type,
            interval: undefined,
            value: data.value as string
        }))
        setCountEnd(true)
    }

    const submitForm = async (e:React.FormEvent<HTMLFormElement>) => {
        e.preventDefault()
        setError(false)
        const formData = new FormData(e.currentTarget)
        const entries = Array.from(formData.entries())
        let deny = false
        let pin = ""

        if(formData.entries()) {

            entries.forEach((entr) => {
                if(typeof entr[1] === "string" && !entr[1].length) {
                    deny = true
                }
                pin += entr[1]
            })
        }


        if(deny) return

        if(pin.length === 4 && data.value.length) {
            setReqLoad(true)
            let is_login_page = false;

            Object.entries(DashboardClass.login_routes).forEach((obj) => {
                if (typeof obj[1] === "string" && window.location.href.includes(obj[1])) {
                    is_login_page = true;
                    return;
                }
            });

            if(is_login_page) {
                localStorage.setItem(CommonClass.local_storage_fields.login_kyc_checking_active, "true")
            }
            await auth.sendLoginOTP(pin, data, isAttemptsErr === "true").then((ok:boolean) => {
                if(!ok) setError(true)
                setReqLoad(false)
            })
        }
    }

    useEffect(() => {
        if(typeof user !== "undefined") {
            if(user.is_pass_code_set) {

                if( sessionStorage.getItem(CommonClass.local_storage_fields.apply_credit_form_body) !== null) {
                    navigate(DashboardClass.dashboard_routes.ApplyCredit)
                } else {
                    navigate(DashboardClass.dashboard_routes.Home)
                }

            } else (
                navigate(DashboardClass.login_routes.LoginStep3)
            )
        }
    }, [user]);

    useEffect(() => {
        if(effectRan.current === false) {

            window.addEventListener(CommonClass.CustomEvents.set_req_load, handleSetReqLoad);
            window.addEventListener(CommonClass.CustomEvents.set_err, handleSetError);

            const timeout = setTimeout(() => {
                if(debug === "true") console.info("setInterval StepTwoForm")

                if((typeof loginData === "string" && loginData.length === 0) || typeof loginData === "undefined" || loginData === null) {

                    navigate(DashboardClass.login_routes.LoginStep1)
                    clearTimeout(timeout)
                }
            }, 3000)
        }

        return () => {
            setPin(init_pin)
            effectRan.current = true
            window.removeEventListener(CommonClass.CustomEvents.set_req_load, handleSetReqLoad)
            window.removeEventListener(CommonClass.CustomEvents.set_err, handleSetError);

        }

    }, []);

    useEffect(() => {
        if(pin.length === 4) {
            let completed = true

            pin.map((x) => {
                if(x === "" || x === " ") {
                    completed = false
                }

            })

            if(completed && formRef.current) {
                formRef.current.requestSubmit()
            }
        }
    }, [pin]);


    return Object.keys(data).length ?  (
        <form className={st.other_steps} ref={formRef} onSubmit={submitForm}>

            <div className={st.top}>

                {isAttemptsErr === "true" ? (
                    <div className={st.heading_att_err}>
                        <div className={st.err_message}>
                            <strong>
                                {t("pin_err")}
                            </strong>
                            <p>
                                {data?.type === "phone" &&  <>{t("att_limit_to_otp_phone")} <br /> <span>{`${country_code} ${data?.value}`}</span> </>}
                                {data?.type === "email" && <>{t("att_limit_to_otp_email")} <br /> <span>{data?.value}</span></>}
                            </p>
                        </div>

                        <span>
                            {t("insert_code")}
                        </span>
                    </div>
                ) : (
                    <div className={st.heading}>
                        {t("insert_code")}

                        <div className={st.info}>
                        <span className={st.inf_text}>
                            {data?.type === "phone" && t("code_sent_to_nr")}
                            {data?.type === "email" && t("code_sent_to_email")}
                        </span>

                            <span className={st.phone_nr}>
                                {(data?.value.length && data?.type === "phone") ? ` ${country_code} ${data?.value}` : ""}
                                {(data?.type === "email" && data?.value.length) ? `${data?.value}` : ""}.
                            </span>

                            <button
                                type={"button"}
                                onClick={() => {
                                    navigate(DashboardClass.login_routes.LoginStep1)
                                }}
                                className={st.edit_number}
                            >
                                <EditIcon/> {t("edit")}
                            </button>
                        </div>
                    </div>
                )}

                <WritePinFields
                    error={error}
                    className={st.pin}
                />
            </div>

            <div className={st.bottom}>
                <Button
                    className={st.back}
                    onClick={() => {
                        navigate(-1);
                        // navigate(DashboardClass.login_routes.LoginStep1)
                    }}
                    type={"button"}
                    outlined
                >
                    <ChevroneIcon/>
                    {t("back")}
                </Button>

                <div className={clsx(st.resend_desktop, st.resend)}>
                    <Button
                        className={clsx(st.resend_btn)}
                        onClick={resend}
                        type={"button"}
                        dark
                        disabled={!countEnd}
                    >
                        <div style={countEnd ? {justifyContent: "center"} : {}} className={st.btn_content}>
                            {!countEnd && (
                                <>
                                    {t("resend_in")}
                                    <Countdown
                                        date={data?.interval}
                                        renderer={(args) => renderer({...args})}
                                        intervalDelay={1000}
                                        zeroPadTime={2}
                                        onComplete={countDownCompleteHandler}
                                    />
                                </>
                            )}

                            <div>
                                <CircleArrow/>
                                {t("resend_code")}
                            </div>
                        </div>
                    </Button>
                </div>

                <div className={clsx(st.resend_mobile, st.resend)}>
                    {!countEnd && (
                        <div className={st.countdown}>
                            {t("resend_in")}
                            <Countdown
                                date={data?.interval}
                                renderer={(args) => renderer({...args})}
                                intervalDelay={1000}
                                zeroPadTime={2}
                                onComplete={countDownCompleteHandler}
                            />
                        </div>
                    )}

                    <Button
                        className={st.resend_btn}
                        onClick={resend}
                        type={"button"}
                        dark
                        disabled={!countEnd}
                    >
                        <div className={st.btn_content}>
                            {/*<div>*/}
                            <CircleArrow/>
                            {t("resend_code")}
                            {/*</div>*/}
                        </div>
                    </Button>
                </div>
            </div>

            {(reqLoad) && <LoginLoader/>}
        </form>
    ) : null
}

const renderer = (args: CountdownRenderProps) => {
    const {minutes, seconds} = args;
    const padValue = (value: number) => (value < 10 ? `0${value}` : `${value}`);

    return (
        <div>
            {padValue(minutes) || "00"} :
            {" " + padValue(seconds) || " 00"}
        </div>
    );

};

export default WriteOTPSecondStep